import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { LANGUAGES_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getLanguagesAction = createAsyncThunk(
    'product/getLanguagesAction',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(LANGUAGES_PATH);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getLanguagesSlice = createSlice({
    name: 'getLanguagesSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getLanguagesAction.pending, () => STATE__API__STARTED);
        builder.addCase(getLanguagesAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getLanguagesAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getLanguagesState = (state) => state.product.getLanguages;
export default getLanguagesSlice.reducer;